var exports = {
  "jr": "AvatarUltraLayer.module__ultra___bjhLeD",
  "Lr": "AvatarUltraLayer.module__ultraVoice___bjhLeD",
  "ur": "AvatarUltraLayer.module__ultraProfile___bjhLeD",
  "Wh": "AvatarUltraLayer.module__ultraCustom___bjhLeD",
};

module.exports = exports;
